// Removes input styling from inline
function remove_input_form_style(list) {
  'use strict';
  var attr = [
    'align',
    'background',
    'bgcolor',
    'border',
    'cellpadding',
    'cellspacing',
    'color',
    'face',
    'height',
    'hspace',
    'marginheight',
    'marginwidth',
    'noshade',
    'nowrap',
    'size',
    'valign',
    'vspace',
    'width',
    'vlink',
    'alink',
    'text',
    'link',
    'frame',
    'frameborder',
    'clear',
    'scrolling',
    'style'
  ];
  var attr_len = attr.length;
  var i = list.length;
  var j;
  var is_hidden;
  while (i--) {
    is_hidden = list[i].style.display === 'none';
    j = attr_len;
    while (j--) {
      list[i].removeAttribute(attr[j]);
    }
    if (is_hidden) {
      list[i].style.display = 'none';
    }
  }
  var set = document.getElementById('edit-revision-log');
  remove_style(set);
}

//Adding USWDS 2.0 class to lists
jQuery(document).ready(function () {
    jQuery('.cd-main-content').find('ul, ol').addClass("usa-list");
});
